if (!customElements.get('ccr-cart-bulb-add')) {
  customElements.define('ccr-cart-bulb-add', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        if (event.target.closest('button')) this.addBulb();
      }, { signal: this.controller.signal });
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.cartReviewRequired = false;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async addBulb() {
      const button = this.querySelector('button');
      if (button.disabled) return;
      if (this.cartReviewRequired) {
        window.location.assign(window.Shopify.routes.root + 'cart');
        return;
      }
      const status = this.querySelector('[role="status"]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.hidden = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: Number(this.dataset.quantity) }], sections: sections.join(','), sections_url: window.Shopify.routes.root + 'cart' }),
          signal: controller.signal
        });
        const result = await response.json();
        if (!response.ok) {
          if (response.status < 500 && typeof result.description === 'string') {
            status.textContent = result.description;
            status.hidden = false;
            return;
          }
          throw new Error('Unconfirmed cart addition');
        }
        if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
          this.cartReviewRequired = true;
          window.location.assign(window.Shopify.routes.root + 'cart');
          return;
        }
        if (!Array.isArray(result.items) || !result.items.length || result.items.some(item => !item?.id) || sections.some(id => typeof result.sections?.[id] !== 'string' || !result.sections[id].trim())) {
          throw new Error('Incomplete cart addition response');
        }
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', { signal: controller.signal });
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();
        if (!Array.isArray(cart.items) || typeof cart.item_count !== 'number') throw new Error('Invalid cart response');
        cart.sections = result.sections;
        this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: result.items, cart, onSuccessDo: 'force_open_drawer' } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart, onSuccessDo: 'force_open_drawer' } }));
      } catch (error) {
        // Refreshing the page reconciles confirmed and uncertain additions alike.
        this.cartReviewRequired = true;
        window.location.assign(window.Shopify.routes.root + 'cart');
      } finally {
        clearTimeout(timeout);
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}

(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.ccr-hook-more[data-target-block-id]');
    if (!link) return;
    const scope = link.closest('product-rerender') || link.closest('.shopify-section');
    const details = scope?.querySelector(`[data-block-id="${CSS.escape(link.dataset.targetBlockId)}"] details`);
    if (!details) return;
    event.preventDefault();
    details.open = true;
    details.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
})();

(() => {
  const mobileQuery = window.matchMedia('(max-width: 699px)');
  const controlSelector = [
    '.header__cart-link > a[aria-controls="cart-drawer"]',
    '.header__primary-nav button[aria-controls="sidebar-menu"]'
  ].join(',');

  let touchCandidate = null;

  const openDialogControl = (control) => {
    const dialogId = control.getAttribute('aria-controls');
    const dialog = dialogId ? document.getElementById(dialogId) : null;

    if (!dialog || typeof dialog.show !== 'function') {
      return false;
    }

    if (dialog.open) {
      dialog.hide?.();
    } else {
      dialog.show(false);
    }

    return true;
  };

  document.addEventListener('touchstart', (event) => {
    if (!mobileQuery.matches || event.touches.length !== 1) {
      touchCandidate = null;
      return;
    }

    const target = event.target.closest?.(controlSelector);

    if (!target) {
      touchCandidate = null;
      return;
    }

    touchCandidate = {
      target,
      x: event.touches[0].clientX,
      y: event.touches[0].clientY,
      time: window.performance.now()
    };
  }, { capture: true, passive: true });

  document.addEventListener('touchend', (event) => {
    if (!touchCandidate || !mobileQuery.matches || event.changedTouches.length !== 1) {
      touchCandidate = null;
      return;
    }

    const touch = event.changedTouches[0];
    const distanceX = Math.abs(touch.clientX - touchCandidate.x);
    const distanceY = Math.abs(touch.clientY - touchCandidate.y);
    const duration = window.performance.now() - touchCandidate.time;
    const target = event.target.closest?.(controlSelector);

    if (target !== touchCandidate.target || distanceX > 8 || distanceY > 8 || duration > 900) {
      touchCandidate = null;
      return;
    }

    touchCandidate = null;

    if (target.hasAttribute('aria-controls') && openDialogControl(target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, { capture: true, passive: false });
})();

(() => {
  // CCR-CUSTOM: scroller vertical des ampoules recommandees. Active uniquement
  // sur desktop : le carrousel horizontal mobile existant reste intact.
  const LIST_SELECTOR = '.ccr-ampoules-scroll.has-scroll';
  const CARD_SELECTOR = ':scope > .ccr-ampoule-card';
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const scrollMemory = new Map();
  const enhancedScrollers = new Map();
  const FULL_CARDS = 3;
  const PEEK_RATIO = 0.45;
  let resizeObserver = null;
  let mutationObserver = null;
  let isEnabled = false;
  const labels = {
    fr: { prev: 'Ampoules précédentes', next: 'Ampoules suivantes' },
    en: { prev: 'Previous bulbs', next: 'Next bulbs' },
    es: { prev: 'Bombillas anteriores', next: 'Bombillas siguientes' }
  };
  const lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  const text = labels[lang] || labels.fr;
  const CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"/></svg>';

  const scrollBehavior = () => (reducedMotionQuery.matches ? 'auto' : 'smooth');

  const keyFor = (list) => {
    const section = list.closest('.shopify-section');
    return `${section?.id || 'product'}:${list.id || 'ampoules'}`;
  };

  // Positions reelles en coordonnees de contenu : les cartes peuvent avoir des
  // hauteurs differentes selon leur nom, leurs badges et le texte du bouton.
  const measure = (list) => {
    const listTop = list.getBoundingClientRect().top - list.scrollTop;
    const items = Array.from(list.querySelectorAll(CARD_SELECTOR))
      .filter((item) => item.offsetHeight > 0)
      .map((item) => {
        const rect = item.getBoundingClientRect();
        return { element: item, start: rect.top - listTop, end: rect.bottom - listTop, height: rect.height };
      });
    const gap = parseFloat(getComputedStyle(list).rowGap) || 0;
    return { items, gap };
  };

  const fitHeight = (wrapper, list) => {
    if (!desktopQuery.matches) return;
    const { items, gap } = measure(list);

    if (items.length <= FULL_CARDS) {
      wrapper.style.removeProperty('--ccr-ba-height');
      return;
    }

    const lastFull = items[FULL_CARDS - 1];
    const next = items[FULL_CARDS];
    const height = Math.round(lastFull.end + gap + next.height * PEEK_RATIO);
    const value = `${height}px`;
    if (wrapper.style.getPropertyValue('--ccr-ba-height') !== value) {
      wrapper.style.setProperty('--ccr-ba-height', value);
    }
  };

  const updateState = (wrapper, list) => {
    const max = list.scrollHeight - list.clientHeight;
    const scrollable = max > 1;
    wrapper.classList.toggle('is-scrollable', scrollable);
    wrapper.classList.toggle('is-at-start', !scrollable || list.scrollTop <= 1);
    wrapper.classList.toggle('is-at-end', !scrollable || list.scrollTop >= max - 1);
  };

  // Defile d'un ecran vertical en alignant le resultat sur une carte reelle.
  const scrollByPage = (list, direction) => {
    const { items } = measure(list);
    const max = list.scrollHeight - list.clientHeight;
    const viewStart = list.scrollTop;
    const viewEnd = viewStart + list.clientHeight;
    let target;

    if (direction > 0) {
      const next = items.find((item) => item.end > viewEnd + 1);
      target = next ? next.start : max;
    } else {
      const first = items.find((item) => item.start >= viewStart - 1) || items[0];
      const wanted = first ? first.end - list.clientHeight : 0;
      const aligned = items.find((item) => item.start >= wanted - 1);
      target = aligned ? aligned.start : 0;
      if (target >= viewStart) target = Math.max(0, wanted);
    }

    list.scrollTo({ top: Math.max(0, Math.min(max, target)), behavior: scrollBehavior() });
  };

  const jumpTo = (list, top) => {
    list.style.setProperty('scroll-behavior', 'auto', 'important');
    list.scrollTop = top;
    list.style.removeProperty('scroll-behavior');
  };

  const makeButton = (direction) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `ccr-ba-scroller__btn ccr-ba-scroller__btn--${direction}`;
    button.setAttribute('aria-label', direction === 'prev' ? text.prev : text.next);
    button.tabIndex = -1; // les cartes restent la navigation clavier
    button.innerHTML = CHEVRON;
    return button;
  };

  const removeRecordListeners = (record) => {
    record.list.removeEventListener('scroll', record.onScroll);
    record.prev.removeEventListener('click', record.onPrevClick);
    record.next.removeEventListener('click', record.onNextClick);
    record.list.removeEventListener('focusin', record.onFocusIn);
  };

  const releaseDetachedResources = () => {
    enhancedScrollers.forEach((record, wrapper) => {
      if (wrapper.isConnected) return;
      removeRecordListeners(record);
      record.observed.forEach((element) => resizeObserver?.unobserve(element));
      enhancedScrollers.delete(wrapper);
    });
  };

  const enhance = (list) => {
    if (!isEnabled || !desktopQuery.matches || !list.isConnected) return;
    const wrapper = list.closest('.ccr-ampoules-wrapper');
    if (!wrapper || wrapper.classList.contains('ccr-ba-scroller')) return;

    wrapper.classList.add('ccr-ba-scroller', 'is-at-start', 'is-at-end');
    const prev = makeButton('prev');
    const next = makeButton('next');
    prev.querySelector('svg').style.transform = 'rotate(-90deg)';
    next.querySelector('svg').style.transform = 'rotate(90deg)';
    wrapper.append(prev, next);

    fitHeight(wrapper, list);

    const key = keyFor(list);
    if (scrollMemory.has(key)) jumpTo(list, scrollMemory.get(key));
    updateState(wrapper, list);

    const onScroll = () => updateState(wrapper, list);
    const onPrevClick = () => scrollByPage(list, -1);
    const onNextClick = () => scrollByPage(list, 1);

    // Si le clavier atteint une carte hors champ, seule la liste se deplace :
    // la page conserve sa position verticale.
    const onFocusIn = (event) => {
      const card = event.target.closest?.('.ccr-ampoule-card');
      if (!card || card.parentElement !== list) return;
      const top = card.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
      const bottom = top + card.offsetHeight;
      if (top < list.scrollTop) {
        list.scrollTo({ top, behavior: scrollBehavior() });
      } else if (bottom > list.scrollTop + list.clientHeight) {
        list.scrollTo({ top: bottom - list.clientHeight, behavior: scrollBehavior() });
      }
    };

    list.addEventListener('scroll', onScroll, { passive: true });
    prev.addEventListener('click', onPrevClick);
    next.addEventListener('click', onNextClick);
    list.addEventListener('focusin', onFocusIn);

    const observed = [wrapper, ...Array.from(list.querySelectorAll(CARD_SELECTOR))];
    enhancedScrollers.set(wrapper, {
      list, prev, next, onScroll, onPrevClick, onNextClick, onFocusIn, observed
    });
    observed.forEach((element) => resizeObserver?.observe(element));
  };

  const enhanceAll = (root = document) => {
    root.querySelectorAll(LIST_SELECTOR).forEach(enhance);
  };

  // Prestige emet cet evenement sans bubbling juste avant de remplacer le bloc.
  const rememberScrollPositions = () => {
    enhancedScrollers.forEach((record) => {
      scrollMemory.set(keyFor(record.list), record.list.scrollTop);
    });
  };

  const handleMutations = (mutations) => {
    let removed = false;
    for (const mutation of mutations) {
      if (mutation.removedNodes.length) removed = true;
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(LIST_SELECTOR)) enhance(node);
        else if (node.querySelector?.(LIST_SELECTOR)) enhanceAll(node);
      }
    }
    if (removed) releaseDetachedResources();
  };

  const enable = () => {
    if (isEnabled || !desktopQuery.matches) return;
    isEnabled = true;

    resizeObserver = new ResizeObserver((entries) => {
      const wrappers = new Set();
      entries.forEach((entry) => {
        const wrapper = entry.target.classList.contains('ccr-ba-scroller')
          ? entry.target
          : entry.target.closest('.ccr-ba-scroller');
        if (wrapper) wrappers.add(wrapper);
      });
      wrappers.forEach((wrapper) => {
        const record = enhancedScrollers.get(wrapper);
        if (!record) return;
        fitHeight(wrapper, record.list);
        updateState(wrapper, record.list);
      });
    });

    mutationObserver = new MutationObserver(handleMutations);
    enhanceAll();
    mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('product:rerender', rememberScrollPositions, true);
  };

  const disable = () => {
    if (!isEnabled) return;
    isEnabled = false;

    mutationObserver?.disconnect();
    mutationObserver = null;
    resizeObserver?.disconnect();
    resizeObserver = null;
    document.removeEventListener('product:rerender', rememberScrollPositions, true);

    enhancedScrollers.forEach((record, wrapper) => {
      removeRecordListeners(record);
      record.prev.remove();
      record.next.remove();
      wrapper.classList.remove('ccr-ba-scroller', 'is-scrollable', 'is-at-start', 'is-at-end');
      wrapper.style.removeProperty('--ccr-ba-height');
      if (record.list.isConnected) jumpTo(record.list, 0);
    });

    enhancedScrollers.clear();
    scrollMemory.clear();
  };

  const syncDesktopState = () => {
    if (desktopQuery.matches) enable();
    else disable();
  };

  desktopQuery.addEventListener('change', syncDesktopState);
  // Secours WebKit : certains contextes embarques recalculent la media query
  // sans emettre son evenement change lors d'un redimensionnement.
  window.addEventListener('resize', syncDesktopState, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDesktopState, { once: true });
  } else {
    syncDesktopState();
  }
})();

// Keep hidden account widgets inert; the normal account link works before hydration.
if (!customElements.get('ccr-deferred-account')) {
  customElements.define('ccr-deferred-account', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('template')) return;
      this.controller?.abort();
      this.controller = new AbortController();
      this.desktop = window.matchMedia('(min-width: 700px)');
      this.drawer = this.closest('header-sidebar');
      const options = { signal: this.controller.signal };
      const check = () => this.mountWhenVisible();
      this.desktop.addEventListener('change', check, options);
      this.drawer?.addEventListener('dialog:before-show', check, options);
      check();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    isAccountVisible() {
      return this.dataset.placement === 'header'
        ? this.desktop.matches
        : !this.desktop.matches && this.drawer?.hasAttribute('open');
    }

    async mountWhenVisible() {
      if (this.pending || !this.isAccountVisible()) return;
      const template = this.querySelector('template');
      if (!template) return;
      this.pending = true;
      await customElements.whenDefined('shopify-account');
      this.pending = false;
      if (!this.isConnected || !this.isAccountVisible()) return;
      template.replaceWith(template.content.cloneNode(true));
      this.querySelector('[data-account-fallback]').hidden = true;
      this.controller?.abort();
    }
  });
}

(() => {
  // CCR-CUSTOM: skip Prestige mega-menu animations from the central custom asset.
  customElements.whenDefined('mega-menu-disclosure').then(() => {
    const MegaMenuDisclosure = customElements.get('mega-menu-disclosure');

    if (!MegaMenuDisclosure?.prototype || MegaMenuDisclosure.prototype.__ccrFastMegaMenuApplied) {
      return;
    }

    const originalShow = MegaMenuDisclosure.prototype.createShowAnimationControls;
    const originalHide = MegaMenuDisclosure.prototype.createHideAnimationControls;

    if (typeof originalShow === 'function') {
      MegaMenuDisclosure.prototype.createShowAnimationControls = function() {
        const controls = originalShow.call(this);

        if (controls && typeof controls.finish === 'function') {
          try {
            controls.finish();
          } catch (error) {
            // Keep the native animation if the browser refuses to finish the control.
          }
        }

        return controls;
      };
    }

    if (typeof originalHide === 'function') {
      MegaMenuDisclosure.prototype.createHideAnimationControls = function() {
        const controls = originalHide.call(this);

        if (controls && typeof controls.finish === 'function') {
          try {
            controls.finish();
          } catch (error) {
            // Keep the native animation if the browser refuses to finish the control.
          }
        }

        return controls;
      };
    }

    MegaMenuDisclosure.prototype.__ccrFastMegaMenuApplied = true;
  });
})();

(() => {
  customElements.whenDefined('header-sidebar').then(() => {
    const HeaderSidebar = customElements.get('header-sidebar');

    if (!HeaderSidebar?.prototype?.revealItems || HeaderSidebar.prototype.__ccrFastRevealApplied) {
      return;
    }

    const originalRevealItems = HeaderSidebar.prototype.revealItems;

    HeaderSidebar.prototype.revealItems = function() {
      const controls = originalRevealItems.call(this, false);

      if (window.matchMedia('(max-width: 699px)').matches && controls && typeof controls.finish === 'function') {
        try {
          controls.finish();
        } catch (error) {
          // Keep the native animation if the browser refuses to finish the control.
        }
      }

      return controls;
    };

    HeaderSidebar.prototype.__ccrFastRevealApplied = true;
  });
})();

(() => {
  // CCR-CUSTOM: variant scroller. Chevrons au survol (desktop), fondu de bord,
  // largeur calee pour couper la derniere vignette visible, memoire de la
  // position de scroll quand Prestige remplace le bloc variant-picker.
  const LIST_SELECTOR = '.variant-picker__option-values';
  const ITEM_SELECTOR = ':scope > label, :scope > a';
  const desktopQuery = window.matchMedia('(min-width: 700px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const scrollMemory = new Map();
  const observedParents = new Set();
  const enhancedScrollers = new Map();
  let resizeObserver = null;
  let mutationObserver = null;
  let isEnabled = false;
  const labels = {
    fr: { prev: 'Options précédentes', next: 'Options suivantes' },
    en: { prev: 'Previous options', next: 'Next options' },
    es: { prev: 'Opciones anteriores', next: 'Opciones siguientes' }
  };
  const lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  const text = labels[lang] || labels.fr;
  const CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"/></svg>';

  const scrollBehavior = () => (reducedMotionQuery.matches ? 'auto' : 'smooth');

  const keyFor = (list) => {
    const picker = list.closest('variant-picker');
    const fieldset = list.closest('fieldset');
    const index = fieldset && fieldset.parentNode ? Array.from(fieldset.parentNode.children).indexOf(fieldset) : 0;
    return `${picker?.getAttribute('form-id') || 'form'}:${index}`;
  };

  // Positions reelles (en coordonnees de contenu) des options visibles :
  // labels (radios) ou liens <a> (produits combines), largeurs quelconques.
  const measure = (list) => {
    const listLeft = list.getBoundingClientRect().left - list.scrollLeft;
    const items = Array.from(list.querySelectorAll(ITEM_SELECTOR))
      .filter((item) => item.offsetWidth > 0)
      .map((item) => {
        const rect = item.getBoundingClientRect();
        return { start: rect.left - listLeft, end: rect.right - listLeft, width: rect.width };
      });
    const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
    return { items, gap };
  };

  const fitWidth = (scroller, list) => {
    scroller.style.removeProperty('--ccr-vp-width');
    if (!desktopQuery.matches) return;
    const { items, gap } = measure(list);
    if (items.length < 2) return;
    const available = scroller.parentElement ? scroller.parentElement.clientWidth : scroller.clientWidth;
    if (!available || items[items.length - 1].end <= available + 1) return;
    // Plus grand nombre de vignettes entieres qui laissent la place a un
    // apercu de 45 % de la suivante.
    let width = 0;
    for (let i = 0; i < items.length - 1; i++) {
      const candidate = items[i].end + gap + Math.round(items[i + 1].width * 0.45);
      if (candidate > available) break;
      width = candidate;
    }
    if (width > 0) scroller.style.setProperty('--ccr-vp-width', `${Math.round(width)}px`);
  };

  const updateState = (scroller, list) => {
    const max = list.scrollWidth - list.clientWidth;
    const scrollable = max > 1;
    scroller.classList.toggle('is-scrollable', scrollable);
    scroller.classList.toggle('is-at-start', !scrollable || list.scrollLeft <= 1);
    scroller.classList.toggle('is-at-end', !scrollable || list.scrollLeft >= max - 1);
  };

  // Defile d'un "ecran" en s'alignant sur le bord d'une vignette.
  const scrollByPage = (list, direction) => {
    const { items } = measure(list);
    const max = list.scrollWidth - list.clientWidth;
    const viewStart = list.scrollLeft;
    const viewEnd = viewStart + list.clientWidth;
    let target;
    if (direction > 0) {
      // La premiere vignette qui deborde a droite devient la premiere visible.
      const next = items.find((item) => item.end > viewEnd + 1);
      target = next ? next.start : max;
    } else {
      // La premiere vignette actuellement visible devient la derniere visible.
      const first = items.find((item) => item.start >= viewStart - 1) || items[0];
      const wanted = first ? first.end - list.clientWidth : 0;
      const aligned = items.find((item) => item.start >= wanted - 1);
      target = aligned ? aligned.start : 0;
      if (target >= viewStart) target = Math.max(0, wanted);
    }
    list.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: scrollBehavior() });
  };

  // scroll-behavior est force en smooth par le CSS : on le neutralise le temps
  // d'un positionnement instantane (restauration, vignette selectionnee).
  const jumpTo = (list, left) => {
    list.style.setProperty('scroll-behavior', 'auto', 'important');
    list.scrollLeft = left;
    list.style.removeProperty('scroll-behavior');
  };

  const revealSelection = (list) => {
    const checked = list.querySelector(':scope > input:checked + label');
    if (!checked) return;
    const left = checked.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
    const right = left + checked.offsetWidth;
    if (left < list.scrollLeft) jumpTo(list, left);
    else if (right > list.scrollLeft + list.clientWidth) jumpTo(list, right - list.clientWidth);
  };

  const makeButton = (direction) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `ccr-vp-scroller__btn ccr-vp-scroller__btn--${direction}`;
    button.setAttribute('aria-label', direction === 'prev' ? text.prev : text.next);
    button.tabIndex = -1; // les vignettes restent la navigation clavier
    button.innerHTML = CHEVRON;
    return button;
  };

  const observeParent = (parent) => {
    if (!resizeObserver || !parent || observedParents.has(parent)) return;
    observedParents.add(parent);
    resizeObserver.observe(parent);
  };

  const removeRecordListeners = (record) => {
    record.list.removeEventListener('scroll', record.onScroll);
    record.prev.removeEventListener('click', record.onPrevClick);
    record.next.removeEventListener('click', record.onNextClick);
    record.list.removeEventListener('focusin', record.onFocusIn);
  };

  const releaseDetachedResources = () => {
    observedParents.forEach((parent) => {
      if (!parent.isConnected) {
        resizeObserver?.unobserve(parent);
        observedParents.delete(parent);
      }
    });

    enhancedScrollers.forEach((record, scroller) => {
      if (!scroller.isConnected) {
        removeRecordListeners(record);
        enhancedScrollers.delete(scroller);
      }
    });
  };

  const enhance = (list) => {
    if (!isEnabled || !desktopQuery.matches || !list.isConnected || list.closest('.ccr-vp-scroller')) return;

    // Prestige redonne le focus au nouvel input apres le re-rendu ; deplacer la
    // liste dans le wrapper le ferait perdre (WebKit). On le memorise et on le remet.
    const active = document.activeElement;
    const hadFocus = active && list.contains(active);

    const scroller = document.createElement('div');
    scroller.className = 'ccr-vp-scroller is-at-start is-at-end';
    list.parentNode.insertBefore(scroller, list);
    scroller.appendChild(list);

    const prev = makeButton('prev');
    const next = makeButton('next');
    prev.querySelector('svg').style.transform = 'scaleX(-1)';
    scroller.append(prev, next);

    fitWidth(scroller, list);

    // Restaure la position de scroll d'avant le re-rendu Prestige (0 compris).
    const key = keyFor(list);
    if (scrollMemory.has(key)) {
      jumpTo(list, scrollMemory.get(key));
    }
    revealSelection(list);

    updateState(scroller, list);

    if (hadFocus && active.isConnected && document.activeElement !== active) {
      try {
        active.focus({ preventScroll: true });
      } catch (error) {
        active.focus();
      }
    }

    const onScroll = () => updateState(scroller, list);
    const onPrevClick = () => scrollByPage(list, -1);
    const onNextClick = () => scrollByPage(list, 1);

    // Navigation clavier : l'input est sr-only, on amene son label dans le champ.
    // Defilement horizontal de la liste uniquement, jamais de la page.
    const onFocusIn = (event) => {
      const label = event.target.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') return;
      const left = label.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
      const right = left + label.offsetWidth;
      if (left < list.scrollLeft) {
        list.scrollTo({ left, behavior: scrollBehavior() });
      } else if (right > list.scrollLeft + list.clientWidth) {
        list.scrollTo({ left: right - list.clientWidth, behavior: scrollBehavior() });
      }
    };

    list.addEventListener('scroll', onScroll, { passive: true });
    prev.addEventListener('click', onPrevClick);
    next.addEventListener('click', onNextClick);
    list.addEventListener('focusin', onFocusIn);

    enhancedScrollers.set(scroller, { list, prev, next, onScroll, onPrevClick, onNextClick, onFocusIn });

    observeParent(scroller.parentElement);
  };

  const enhanceAll = (root = document) => {
    root.querySelectorAll(LIST_SELECTOR).forEach(enhance);
  };

  // Prestige emet product:rerender (sans bubbling) sur le <form> juste avant de
  // remplacer le bloc : on memorise la position de chaque liste en phase capture.
  const rememberScrollPositions = () => {
    document.querySelectorAll(`.ccr-vp-scroller > ${LIST_SELECTOR}`).forEach((list) => {
      scrollMemory.set(keyFor(list), list.scrollLeft);
    });
  };

  const handleMutations = (mutations) => {
    let removed = false;
    for (const mutation of mutations) {
      if (mutation.removedNodes.length) removed = true;
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(LIST_SELECTOR)) enhance(node);
        else if (node.querySelector?.(LIST_SELECTOR)) enhanceAll(node);
      }
    }
    if (removed) releaseDetachedResources();
  };

  const enable = () => {
    if (isEnabled || !desktopQuery.matches) return;
    isEnabled = true;

    resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const scroller = entry.target.querySelector(':scope > .ccr-vp-scroller');
        const list = scroller?.querySelector(LIST_SELECTOR);
        if (!scroller || !list) return;
        const previousScroll = list.scrollLeft;
        fitWidth(scroller, list);
        jumpTo(list, previousScroll);
        revealSelection(list);
        updateState(scroller, list);
      });
    });

    mutationObserver = new MutationObserver(handleMutations);
    enhanceAll();
    mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('product:rerender', rememberScrollPositions, true);
  };

  const disable = () => {
    if (!isEnabled) return;
    isEnabled = false;

    mutationObserver?.disconnect();
    mutationObserver = null;
    resizeObserver?.disconnect();
    resizeObserver = null;
    observedParents.clear();
    document.removeEventListener('product:rerender', rememberScrollPositions, true);

    enhancedScrollers.forEach((record, scroller) => {
      removeRecordListeners(record);
      const { list } = record;
      if (!scroller.isConnected || !list.isConnected) return;

      const active = document.activeElement;
      const hadFocus = active && list.contains(active);
      scroller.replaceWith(list);

      if (hadFocus && active.isConnected && document.activeElement !== active) {
        try {
          active.focus({ preventScroll: true });
        } catch (error) {
          active.focus();
        }
      }
    });

    enhancedScrollers.clear();
    scrollMemory.clear();
  };

  const syncDesktopState = () => {
    if (desktopQuery.matches) enable();
    else disable();
  };

  desktopQuery.addEventListener('change', syncDesktopState);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDesktopState, { once: true });
  } else {
    syncDesktopState();
  }
})();
